function isValidDate(d) {
  return d instanceof Date && !isNaN(d.getTime());
}

export default isValidDate;
